var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBubbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 544,
    viewBox: "0 0 172 544",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.4316 70.9343C87.7209 62.3859 74.0364 60.3247 72.747 68.8731C71.3718 77.9914 85.0564 80.0526 86.4316 70.9343Z",
    fill: "url(#paint0_linear_mobile_navigation_bubbles)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.379 346.21C154.066 341.651 147.224 340.62 146.536 345.18C145.849 349.739 152.691 350.769 153.379 346.21Z",
    fill: "url(#paint1_linear_mobile_navigation_bubbles)",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.345 49.3103C137.032 44.7512 130.19 43.7206 129.502 48.2797C128.815 52.8388 135.657 53.8695 136.345 49.3103Z",
    fill: "url(#paint2_linear_mobile_navigation_bubbles)",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.009 536.632C72.6421 525.804 55.5363 523.227 53.9032 534.055C52.1841 545.453 69.2899 548.029 71.009 536.632Z",
    fill: "url(#paint3_linear_mobile_navigation_bubbles)",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.89 219.608C173.523 208.78 156.418 206.204 154.784 217.031C153.151 227.859 170.257 230.436 171.89 219.608Z",
    fill: "url(#paint4_linear_mobile_navigation_bubbles)",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8594 190.69C101.493 179.862 84.3867 177.286 82.7536 188.114C81.0346 199.512 98.1403 202.088 99.8594 190.69Z",
    fill: "url(#paint5_linear_mobile_navigation_bubbles)",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6523 413.566C94.9416 405.018 81.257 402.956 79.9677 411.505C78.5924 420.623 92.2771 422.684 93.6523 413.566Z",
    fill: "url(#paint6_linear_mobile_navigation_bubbles)",
    fillOpacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5141 304.607C75.8034 296.058 62.1188 293.997 60.8295 302.545C59.4542 311.664 73.1389 313.725 74.5141 304.607Z",
    fill: "url(#paint7_linear_mobile_navigation_bubbles)",
    fillOpacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2503 202.138C20.5396 193.589 6.855 191.528 5.5657 200.077C4.27639 208.625 17.961 210.686 19.2503 202.138Z",
    fill: "url(#paint8_linear_mobile_navigation_bubbles)",
    fillOpacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7702 7.53421C15.0595 -1.01419 1.37489 -3.0754 0.0855842 5.473C-1.20372 14.0214 12.4809 16.0826 13.7702 7.53421Z",
    fill: "url(#paint9_linear_mobile_navigation_bubbles)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_mobile_navigation_bubbles",
    x1: -198.171,
    y1: 72.2608,
    x2: 185.778,
    y2: 457.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_mobile_navigation_bubbles",
    x1: -198.171,
    y1: 72.2608,
    x2: 185.778,
    y2: 457.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_mobile_navigation_bubbles",
    x1: -198.171,
    y1: 72.2608,
    x2: 185.778,
    y2: 457.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_mobile_navigation_bubbles",
    x1: -198.171,
    y1: 72.2608,
    x2: 185.778,
    y2: 457.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_mobile_navigation_bubbles",
    x1: -198.171,
    y1: 72.2608,
    x2: 185.778,
    y2: 457.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_mobile_navigation_bubbles",
    x1: -198.171,
    y1: 72.2608,
    x2: 185.778,
    y2: 457.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_mobile_navigation_bubbles",
    x1: -198.171,
    y1: 72.2608,
    x2: 185.778,
    y2: 457.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_mobile_navigation_bubbles",
    x1: -198.171,
    y1: 72.2608,
    x2: 185.778,
    y2: 457.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_mobile_navigation_bubbles",
    x1: -198.171,
    y1: 72.2608,
    x2: 185.778,
    y2: 457.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_mobile_navigation_bubbles",
    x1: -198.171,
    y1: 72.2608,
    x2: 185.778,
    y2: 457.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/bubbles.962cc797.svg";
export { ForwardRef as ReactComponent };